'use client';

import { useMergeRefs } from '@floating-ui/react';
import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { DatePickerRootContext } from './context/date-picker-root.context';
import { datePickerInputGroupRecipe } from './styles/date-picker-input-group.styles';
import type { DatePickerInputGroupPropsInterface } from './types/date-picker-input-group.types';

/**
 * @since 10.0.0
 */
export const DatePickerInputGroup = forwardRef<HTMLDivElement, DatePickerInputGroupPropsInterface>(
  (props: DatePickerInputGroupPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;

    const { datePicker, disabled, error, readOnly, size } = useContext(DatePickerRootContext);

    const mergedRefs = useMergeRefs([datePicker.refs.setPositionReference, forwardedRef]);

    const styles = css(
      datePickerInputGroupRecipe.raw({ disabled, error, readOnly, size }),
      cssProp,
    );

    return (
      <div
        ref={mergedRefs}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="DatePicker.InputGroup"
        className={cx('c11n', 'group', styles, className)}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

DatePickerInputGroup.displayName = 'DatePicker.InputGroup';
